import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-payments-icon',
	templateUrl: './payments-icon.component.html',
})
export class PaymentsIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
